import {
  DEFAULT_ATTRIBUTE,
  DEFAULT_LIGHT_THEME,
  DEFAULT_STORAGE_KEY,
  DEFAULT_SYSTEM_THEME,
  DEFAULT_THEMES,
} from 'lib/next-themes/constants';
import useThemeProvider from 'lib/next-themes/provider.hook';
import ThemeScript from 'lib/next-themes/theme-script';
import type { ReactElement } from 'react';

import ThemeContext from './context';
import type { ThemeProviderProps } from './types';

export default function ThemeProvider({
  attribute = DEFAULT_ATTRIBUTE,
  disableTransitionOnChange = false,
  enableSystem = true,
  enableColorScheme = true,
  storageKey = DEFAULT_STORAGE_KEY,
  defaultTheme = enableSystem ? DEFAULT_SYSTEM_THEME : DEFAULT_LIGHT_THEME,
  themes = DEFAULT_THEMES,
  ...props
}: ThemeProviderProps): ReactElement {
  const themeContextValue = useThemeProvider({
    attribute,
    disableTransitionOnChange,
    defaultTheme,
    enableSystem,
    enableColorScheme,
    themes,
    storageKey,
    ...props,
  });

  return (
    <ThemeContext.Provider value={themeContextValue}>
      <ThemeScript
        attribute={attribute}
        defaultTheme={defaultTheme}
        disableTransitionOnChange={disableTransitionOnChange}
        enableColorScheme={enableColorScheme}
        enableSystem={enableSystem}
        forcedTheme={props.forcedTheme}
        nonce={props.nonce}
        storageKey={storageKey}
        themeValues={themeContextValue.themeValues}
        themes={themes}
        value={props.value}
      />
      {props.children}
    </ThemeContext.Provider>
  );
}
